export class TaskTemplateStep {
    public id?: number;
    public positionIndex: number;
    public description: string;
    public pictureUrl?: string;
    public createdAt: Date;
    public lastUpdatedAt: Date;
    public videoUrl?: string;
    public videoThumbnailUrl?: string;

    public pictureFile?: File;
    public videoFile?: File;
    public videoThumbnailFile?: File;

    public duplicatedFromTaskTemplateStepId?: number;
}


// WEBPACK FOOTER //
// ./src/Models/Tasks/TaskTemplateStep.ts